module.exports = __webpack_public_path__ + "static/media/test1 (10).48e743a8.jpg";